import { cn } from '@/lib/utils';

interface Props {
  children: React.ReactNode;
  fullWidth?: boolean;
}

export function Container({ children, fullWidth }: Props) {
  return <div className={cn("container mx-auto px-4 md:px-6 lg:px-8", fullWidth ? 'w-full' : 'max-w-7xl')}>{children}</div>
}